import { render, staticRenderFns } from "./NotificationInApp.vue?vue&type=template&id=5ec31043&scoped=true&"
import script from "./NotificationInApp.vue?vue&type=script&lang=js&"
export * from "./NotificationInApp.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInApp.vue?vue&type=style&index=0&id=5ec31043&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec31043",
  null
  
)

export default component.exports